// Aid el-Adha — activation via paramètres BDD (voir AidSettingsPanel)
// computeAidActive() est la source de vérité principale.
// isAidModeActive() reste disponible comme fallback statique.

export function isAidModeActive() {
  const now = new Date();
  const start = new Date('2026-05-25T00:00:00');
  const end   = new Date('2026-06-01T23:59:59');
  return now >= start && now <= end;
}

// Calcule si le thème Aid est actif à partir des paramètres reçus de l'API.
// settings = { enabled, aidDate, daysBefore, daysAfter }
export function computeAidActive(settings) {
  if (!settings) return isAidModeActive();
  if (!settings.enabled || !settings.aidDate) return false;

  const aid   = new Date(settings.aidDate);
  const start = new Date(aid);
  start.setDate(start.getDate() - (Number(settings.daysBefore) || 1));
  start.setHours(0, 0, 0, 0);

  const end = new Date(aid);
  end.setDate(end.getDate() + (Number(settings.daysAfter) || 3));
  end.setHours(23, 59, 59, 999);

  const now = new Date();
  return now >= start && now <= end;
}

// Formate la période active en français (ex: "26 mai → 30 mai 2026")
export function formatAidPeriod(settings) {
  if (!settings || !settings.aidDate) return '';
  const aid   = new Date(settings.aidDate);
  const start = new Date(aid);
  start.setDate(start.getDate() - (Number(settings.daysBefore) || 1));
  const end = new Date(aid);
  end.setDate(end.getDate() + (Number(settings.daysAfter) || 3));

  const fmt = (d) => d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' });
  return `${fmt(start)} → ${fmt(end)}`;
}
